// ProgressView.tsx - hosts the two progress surfaces under one segmented pill (Progress | Session
// debrief), owns the data load (useProgress) + the cadence knob, and reads deep-link params
// ?mode=progress&view=dashboard|debrief[&session=<id>][&seed=1] (S25). Presentational children stay pure.
import { useState } from 'react';
import type { CoachingCadence } from '@postflop/schema';
import { useProgress } from './useProgress';
import { ProgressDashboard } from './ProgressDashboard';
import { SeriesDebrief } from './SeriesDebrief';

type View = 'dashboard' | 'debrief';

function initialView(): View {
  if (typeof window === 'undefined') return 'dashboard';
  return new URLSearchParams(window.location.search).get('view') === 'debrief' ? 'debrief' : 'dashboard';
}
function initialSession(): string | null {
  if (typeof window === 'undefined') return null;
  return new URLSearchParams(window.location.search).get('session');
}

export function ProgressView() {
  const [view, setView] = useState<View>(initialView);
  const [cadence, setCadence] = useState<CoachingCadence>('perHand');
  const { dashboard, debrief, loading } = useProgress(initialSession(), cadence);

  const swap = (v: View) => {
    setView(v);
    if (typeof window !== 'undefined') {
      const p = new URLSearchParams(window.location.search);
      p.set('mode', 'progress');
      p.set('view', v);
      history.replaceState(null, '', `?${p.toString()}`);
    }
  };

  return (
    <div className="body">
      <div className="vpill">
        <button type="button" className={view === 'dashboard' ? 'on' : ''} onClick={() => swap('dashboard')}>
          Progress
        </button>
        <button type="button" className={view === 'debrief' ? 'on' : ''} onClick={() => swap('debrief')}>
          Session debrief
        </button>
      </div>

      {loading ? (
        <div className="ploading num">Loading your progress...</div>
      ) : view === 'dashboard' ? (
        <ProgressDashboard data={dashboard} />
      ) : (
        <SeriesDebrief data={debrief} onCadence={setCadence} />
      )}
    </div>
  );
}
